module.exports = __webpack_public_path__ + "static/img/KPG.86f9f45.png";


//////////////////
// WEBPACK FOOTER
// ./static/seriesPic/KPG.png
// module id = 0e8q
// module chunks = 1